// extracted by mini-css-extract-plugin
export default {"error":"ErrorPage_error__jdhPg","debugDetails":"ErrorPage_debugDetails__9D3G1"};